import React from 'react';
import {
  GeneratePaymentRequestWizard,
  GeneratePaymentRequestWizardPageStep,
  PaymentRequestDetails,
  PaymentRequestSent,
  PreferredPaymentRequest,
  Summary,
} from 'src/containers/self-service/generate-payment-request/components';

export default function GeneratePaymentRequest() {
  const [currentStepIndex, setCurrentStepIndex] = React.useState<number>(0);

  const steps: GeneratePaymentRequestWizardPageStep[] = [
    {
      page: (props) => <PreferredPaymentRequest {...props} />,
      name: 'Payment Method',
    },
    {
      page: (props) => <PaymentRequestDetails {...props} />,
      name: 'Payment Details',
    },
    {
      page: (props) => <Summary {...props} />,
      name: 'Summary',
    },
    {
      page: (props) => <PaymentRequestSent {...props} />,
      name: 'Request Sent',
    },
  ];

  return (
    <div className="[&_.NavigationFooter]:sticky">
      <GeneratePaymentRequestWizard
        steps={steps}
        setCurrentStepIndex={setCurrentStepIndex}
        currentStepIndex={currentStepIndex}
      />
    </div>
  );
}
